import { useEffect, useState } from "react";
import { Table } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useDispatch, useSelector } from "react-redux";
import { getSitesListbyclientId, fetchAllSites } from "../../store/actions";
import { managesites_column } from "../../helpers/columns";
import { MantineModal } from "../../components/mantine/modal";
import { MantineGrid, MantineGridColumn } from "../../components/mantine/grid";
import { useCustomMediaQuery, PlaceholderUi } from "../../helpers/common";
import { useStateContext } from "../../Contexts/ContextProvider";
import { getClientdropdown } from "../../store/actions";
import { useNavigate, useParams } from 'react-router-dom';
import { useDebounce } from "../../utlis/debounceHook";
import MantineCloseButton from "../../components/mantine/closeButton";
import MantineTextInput from "../../components/mantine/textinput";
import DeleteConfirmation from "./deleteSite";
import MantineButton from "../../components/mantine/button";
import MantinePagination from "../../components/mantine/pagination";
import MantineGroup from "../../components/mantine/group";
import MantineContainer from "../../components/mantine/container";
import UserForm from "./UserForm";
import TitleComponent from "../../components/common/title";
import StatusComponent from '../../pages/managesites/Components/StatusComponents';
import ActionMenu from './Components/ActionMenu';
import moment from "moment";
import CustomModalHeaderTitle from "../../components/common/customModalHeaderTitle";

export default function ManageUserProfile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState<any>('');
  const [pageSize, setPageSize] = useState<any>(5);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [activepageNumber, setActivePageNumber] = useState<any>(1);
  const [selectedRows, SetSelectedRows] = useState<any>([])
  const [opened, { open, close }] = useDisclosure(false); // modal open close functionality
  const [openedConfirmationPopup, { open: openConfirmationPopup, close: closeConfirmationPopup }] = useDisclosure(false); // modal open close functionality
  const { currentPrimaryColor, currentSecondaryColor } = useStateContext();
  const { isLargeScreenmin, isSmallScreen } = useCustomMediaQuery();
  const debouncedQuery = useDebounce(searchValue, 500);
  const [OpenedDeletePopUp, { open: OpendeletePopUp, close: closeDeletePopUp }] = useDisclosure(false);
  const { getSite, Count } = useSelector((state: any) => ({
    getSite: state?.getsiteData?.sitelist,
    Count: state?.getsiteData?.totalCount,
  }));
  const { clientId } = useParams();

  useEffect(() => {
    if (clientId) {
      getList();
    }
  }, [pageNumber, pageSize, clientId, debouncedQuery])

  useEffect(() => {
    if (searchValue?.length == 0) {
      const data = {
        "clientId": clientId,
        "pageNumber": activepageNumber,
        "pageSize": pageSize,
        "sortColumn": "",
        "sortDirection": "",
        "searchKeyword": searchValue
      }
      dispatch(getSitesListbyclientId(data))
    }
  }, [searchValue])

  const getList = () => {
    const data = {
      "clientId": clientId,
      "pageNumber": pageNumber,
      "pageSize": pageSize,
      "sortColumn": "",
      "sortDirection": "",
      "searchKeyword": searchValue
    }
    dispatch(getSitesListbyclientId(data))
  }

  const handleResponseUserForm = (status: any) => {
    if (status === "SUCCESS" || status === "ADD SUCCESS") close(); getList();
    if (opened) {
      close();
    } else {
      open();
    }
  }

  // report download concept
  const getsiteReport = (reports: any) => {
    const userdata:any= {
      "clientId": clientId,
      "pageNumber": pageNumber,
      "pageSize": pageSize,
      "sortColumn": "",
      "sortDirection": "",
      "searchKeyword": searchValue,
      isExport: true
    }

    if (!reports) {
      userdata.pageNumber = pageNumber;
      userdata.pageSize = pageSize;
  }
    if (reports == true) dispatch(getSitesListbyclientId(userdata, "export", `${moment(Date()).format('YYYY_MM_DD')}_site_list`))
  }

  const { getClient, getsitename } = useSelector((state: any) => ({
    getClient: state?.getclientData?.clientdropdown,
    getsitename: state?.getsiteData?.getSite,
  }));

  const getClientLists = () => {
    const data = {
      "pageNumber": "1",
      "pageSize": "1000",
      "sortColumn": "",
      "sortDirection": "",
      "searchKeyword": searchValue
    }
    dispatch(getClientdropdown(data))
  }


  const clientNames = getClient?.map((client: any) => ({ value: String(client.id), label: client.name }));
  const sitenameNames = getsitename?.map((site: any) => ({ value: String(site.id), label: site.siteName }));


  useEffect(() => {
    dispatch(fetchAllSites())
  }, [])

  const handlePageSizeChange = (value: string) => {
    setPageSize(Number(value));
    setPageNumber(1);
  };

  const handleCloseValue = () => {
    setSearchValue('');
  }


  const handleDelete = () => {
    closeDeletePopUp()
    getList();
  }

  useEffect(() => {
    getClientLists();

  }, [pageNumber, pageSize])

  const rows = getSite?.map((item: any, index: any) => (
    <Table.Tr key={index}>
      <Table.Td data-label="Sites">{item.siteName}</Table.Td>
      <Table.Td data-label="Site Address">{item.address}</Table.Td>
      <Table.Td data-label="Status">
        <StatusComponent item={item.siteIsActive} />
      </Table.Td>
      <Table.Td data-label="Latiude">{item.latitude}</Table.Td>
      <Table.Td data-label="Longitude">{item.longitude}</Table.Td>
      <Table.Td data-label="Client Name">{item.clientName}</Table.Td>
      <Table.Td data-label="Action">
        <ActionMenu
          item={item}
          open={open}
          SetSelectedRows={SetSelectedRows}
          OpendeletePopUp={OpendeletePopUp}
        />
      </Table.Td>
    </Table.Tr>
  ));
  const classButton = `w-fit text-sm font-thin ${isSmallScreen && 'w-full'}`  // multiple time css call so single line convert
  return (
    <div className="w-full mt-4">
      <TitleComponent title="Manage Sites" />
      <MantineContainer fluid={true} className="m-auto bg-white my-6 px-5">
        <MantineGrid className="py-5" grow={true}>

          <MantineGridColumn span={{ base: 12, md: 3, lg: 3 }} >
            <form onSubmit={(event: any) => { event.preventDefault(); setPageNumber(1); getList() }}>
              <MantineTextInput
                placeholder={`Search by Name`}
                onChange={(event: any) => { setSearchValue(event.currentTarget?.value) }}
                value={searchValue}
                rightSection={searchValue?.length >= 1 && <MantineCloseButton onClick={() => handleCloseValue()} />}
                classNames={{ input: `${PlaceholderUi}` }}
              />
            </form>
          </MantineGridColumn>
          <MantineGridColumn span={{ base: 12, md: 3, lg: 3 }}>
            <MantineButton
              name={'Search'}
              color={currentPrimaryColor}
              className={classButton}
              onClick={() => { getList() }}
            />
          </MantineGridColumn>
          <MantineGridColumn span={{ base: 12, md: 6, lg: 6 }}>
            <MantineGroup justify="flex-end">
              <MantineButton
                name={'+ Add New Sites'}
                className={classButton}
                color={currentPrimaryColor}
                onClick={() => { open(); SetSelectedRows([]) }}
              />
              <MantineButton
                name={'Export'}
                color={currentPrimaryColor}
                onClick={() => getsiteReport(true)}
                className={classButton}
              />
            </MantineGroup>
          </MantineGridColumn>
        </MantineGrid>
      </MantineContainer>
      <MantineContainer fluid={true} className="m-auto bg-white pt-5 px-5 pb-10">
        <div className={`${rows?.length !== 0 && 'mobile-responsive-scroll'}`}>
          <Table className="bg-global_bg" verticalSpacing="sm">
            <Table.Thead>
              <Table.Tr>
                {managesites_column?.map((data: any) => (
                  <Table.Th key={data.id}>{data.name}</Table.Th>
                ))}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {rows?.length === 0 ? (
                <Table.Tr>
                  <Table.Td colSpan={managesites_column.length} className={`${isLargeScreenmin ? 'mt-4 text-center' : 'text-center'}`}>
                    No Data Found
                  </Table.Td>
                </Table.Tr>
              ) : rows}
            </Table.Tbody>
          </Table>
        </div>
        <MantineGroup className={`justify-end pt-5 ${rows?.length == 0 && isLargeScreenmin && 'pb-8'}`}>
          {rows?.length != 0 &&
            <MantinePagination
              total={Math.ceil(Count / pageSize)}
              onChange={(value: any) => { setPageNumber(value); setActivePageNumber(value) }}
              color={currentPrimaryColor}
              withEdges={true}
              valueSelect={pageSize}
              size={"md"}
              className='m-auto pb-4'
              onChangeSelect={handlePageSizeChange}
              value={searchValue?.length != 0 ? pageNumber : activepageNumber}
            />
          }
        </MantineGroup>
        <MantineModal size={"xl"} opened={opened} onClose={close} title={<CustomModalHeaderTitle title={`${selectedRows?.length == 0 ? "Add" : "Edit"} Site`} onClick={close} />}>
          <UserForm userData={selectedRows} handleResponseUserForm={handleResponseUserForm} modalclose={close} dispatch={dispatch} currentPrimaryColor={currentPrimaryColor} currentSecondaryColor={currentSecondaryColor} clientNames={clientNames} sitenameNames={sitenameNames} />
        </MantineModal>
        <MantineModal opened={OpenedDeletePopUp} onClose={closeDeletePopUp} title={<CustomModalHeaderTitle title='Delete' onClick={closeDeletePopUp} />}>
          <DeleteConfirmation item={selectedRows} modalclose={closeDeletePopUp} handleDelete={handleDelete} currentPrimaryColor={currentPrimaryColor} currentSecondaryColor={currentSecondaryColor} />
        </MantineModal>
      </MantineContainer>
    </div>
  );
}


